import { render, staticRenderFns } from "./BasicDisplayTable.vue?vue&type=template&id=8fa0e328"
import script from "./BasicDisplayTable.vue?vue&type=script&lang=js"
export * from "./BasicDisplayTable.vue?vue&type=script&lang=js"
import style0 from "./BasicDisplayTable.vue?vue&type=style&index=0&id=8fa0e328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports